import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from 'i18n/translations/en/common.json';
import enNewOrder from 'i18n/translations/en/new_order.json';
import enOrderHistory from 'i18n/translations/en/order_history.json';
import enProfile from 'i18n/translations/en/profile.json';
import enRedeem from 'i18n/translations/en/redeem.json';
import zhCommon from 'i18n/translations/zh/common.json';
import zhNewOrder from 'i18n/translations/zh/new_order.json';
import zhOrderHistory from 'i18n/translations/zh/order_history.json';
import zhProfile from 'i18n/translations/zh/profile.json';
import zhRedeem from 'i18n/translations/zh/redeem.json';
import enLayout from 'i18n/translations/en/layout.json';
import zhLayout from 'i18n/translations/zh/layout.json';
import enCreditCard from 'i18n/translations/en/credit_card.json';
import zhCreditCard from 'i18n/translations/zh/credit_card.json';
import enTips from 'i18n/translations/en/tips.json';
import zhTips from 'i18n/translations/zh/tips.json';
import enWallet from 'i18n/translations/en/wallet.json';
import zhWallet from 'i18n/translations/zh/wallet.json';
import enBenefits from 'i18n/translations/en/benefits.json';
import zhBenefits from 'i18n/translations/zh/benefits.json';
import enLanding from 'i18n/translations/en/landing.json';
import zhLanding from 'i18n/translations/zh/landing.json';
import enNotFound from 'i18n/translations/en/not_found.json';
import zhNotFound from 'i18n/translations/zh/not_found.json';
import enNewOrderResult from 'i18n/translations/en/new_order_result.json';
import zhNewOrderResult from 'i18n/translations/zh/new_order_result.json';
import enLogin from 'i18n/translations/en/login.json';
import zhLogin from 'i18n/translations/zh/login.json';
import enRegistration from 'i18n/translations/en/registration.json';
import zhRegistration from 'i18n/translations/zh/registration.json';
import enTermsAndConditions from 'i18n/translations/en/terms_and_conditions.json';
import zhTermsAndConditions from 'i18n/translations/zh/terms_and_conditions.json';
import enPasswordForm from 'i18n/translations/en/password_form.json';
import zhPasswordForm from 'i18n/translations/zh/password_form.json';
import enPassword from 'i18n/translations/en/password.json';
import zhPassword from 'i18n/translations/zh/password.json';
import enPasswordResetSuccess from 'i18n/translations/en/password_reset_success.json';
import zhPasswordResetSuccess from 'i18n/translations/zh/password_reset_success.json';
import enPasswordUpdateSuccess from 'i18n/translations/en/password_update_success.json';
import zhPasswordUpdateSuccess from 'i18n/translations/zh/password_update_success.json';
import enPasswordResetEmailSent from 'i18n/translations/en/password_reset_email_sent.json';
import zhPasswordResetEmailSent from 'i18n/translations/zh/password_reset_email_sent.json';
import enPasswordCreateOrReset from 'i18n/translations/en/password_create_or_reset.json';
import zhPasswordCreateOrReset from 'i18n/translations/zh/password_create_or_reset.json';
import enEmail from 'i18n/translations/en/email.json';
import zhEmail from 'i18n/translations/zh/email.json';
import enEmailSent from 'i18n/translations/en/email_sent.json';
import zhEmailSent from 'i18n/translations/zh/email_sent.json';
import enEmailInputEmailVerified from 'i18n/translations/en/email_input_email_verified.json';
import zhEmailInputEmailVerified from 'i18n/translations/zh/email_input_email_verified.json';
import enEmailLinkExpired from 'i18n/translations/en/email_link_expired.json';
import zhEmailLinkExpired from 'i18n/translations/zh/email_link_expired.json';
import enEmailLinkExpiredWithSignUp from 'i18n/translations/en/email_link_expired_with_sign_up.json';
import zhEmailLinkExpiredWithSignUp from 'i18n/translations/zh/email_link_expired_with_sign_up.json';
import enEmailVerify from 'i18n/translations/en/email_verify.json';
import zhEmailVerify from 'i18n/translations/zh/email_verify.json';
import enPasswordResetVerify from 'i18n/translations/en/password_reset_verify.json';
import zhPasswordResetVerify from 'i18n/translations/zh/password_reset_verify.json';
import enSessionExpired from 'i18n/translations/en/session_expired.json';
import zhSessionExpired from 'i18n/translations/zh/session_expired.json';

const resources = {
  en: {
    common: enCommon,
    new_order: enNewOrder,
    order_history: enOrderHistory,
    profile: enProfile,
    redeem: enRedeem,
    layout: enLayout,
    creditCard: enCreditCard,
    tips: enTips,
    wallet: enWallet,
    benefits: enBenefits,
    landing: enLanding,
    not_found: enNotFound,
    new_order_result: enNewOrderResult,
    login: enLogin,
    registration: enRegistration,
    terms_and_conditions: enTermsAndConditions,
    password_form: enPasswordForm,
    password: enPassword,
    password_reset_success: enPasswordResetSuccess,
    password_update_success: enPasswordUpdateSuccess,
    password_reset_email_sent: enPasswordResetEmailSent,
    password_create_or_reset: enPasswordCreateOrReset,
    email: enEmail,
    email_sent: enEmailSent,
    email_input_email_verified: enEmailInputEmailVerified,
    email_link_expired: enEmailLinkExpired,
    email_link_expired_with_sign_up: enEmailLinkExpiredWithSignUp,
    email_verify: enEmailVerify,
    password_reset_verify: enPasswordResetVerify,
    session_expired: enSessionExpired,
  },
  zh: {
    common: zhCommon,
    new_order: zhNewOrder,
    order_history: zhOrderHistory,
    profile: zhProfile,
    redeem: zhRedeem,
    layout: zhLayout,
    creditCard: zhCreditCard,
    tips: zhTips,
    wallet: zhWallet,
    benefits: zhBenefits,
    landing: zhLanding,
    not_found: zhNotFound,
    new_order_result: zhNewOrderResult,
    login: zhLogin,
    registration: zhRegistration,
    terms_and_conditions: zhTermsAndConditions,
    password_form: zhPasswordForm,
    password: zhPassword,
    password_reset_success: zhPasswordResetSuccess,
    password_update_success: zhPasswordUpdateSuccess,
    password_reset_email_sent: zhPasswordResetEmailSent,
    password_create_or_reset: zhPasswordCreateOrReset,
    email: zhEmail,
    email_sent: zhEmailSent,
    email_input_email_verified: zhEmailInputEmailVerified,
    email_link_expired: zhEmailLinkExpired,
    email_link_expired_with_sign_up: zhEmailLinkExpiredWithSignUp,
    email_verify: zhEmailVerify,
    password_reset_verify: zhPasswordResetVerify,
    session_expired: zhSessionExpired,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    defaultNS: 'common',
    debug: false,
    interpolation: {escapeValue: false,},
    resources,
    react: {useSuspense: true},
  });

export default i18n;